/* eslint-disable react-hooks/exhaustive-deps */
import { Table, Tag, Button, Pagination, Input, Space, Form, Select } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";

import UsersFilters from "./Filters";
import { searchOptions } from "./helper.jsx";
import ModifyUserAccessConfigModal from "./ModifyUserAccessConfigModal/index.jsx";
import PaymentsModal from "./PaymentsModal";
import PurchasedCoursesModal from "./PurchasedCoursesModal";
import UserDetailsModal from "./UserDetailsModal";
import {
  showErrorNotification,
  showNotification,
  showSuccessNotification
} from "../../utils/notification";
import { clamp } from "../../utils/responsiveHelpers";
import ConfirmationModal from "../common-utils/ConfirmationModal";

const UsersDash = ({ adminConfig = {}, ROOT_URL }) => {
  const FILE_UPLOAD_BACKEND_URL = `${ROOT_URL}/admin/users/fetch-emails-from-file`;

  const [userList, setUserList] = useState([]);
  const [isUserConfirmationAction, setIsUserConfirmationAction] = useState(false);
  const [userConfirmationActionMessage, setUserConfirmationActionMessage] = useState("");
  const [criticalActionUserId, setCriticalActionUserId] = useState("");
  const [isPurchasedCoursesViewModalOpen, setIsPurchasedCoursesViewModalOpen] = useState(false);
  const [userPurchasedCourses, setUserPurchasedCourses] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [showFiltersSidebar, setShowFilterSidebar] = useState(false);
  const [formRequisites, setFormRequisites] = useState({});
  const [userPayments, setUserPayments] = useState([]);
  const [isPaymentDetailsModalOpen, setIsPaymentDetailsModalOpen] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [paymentFilterOptions, setpaymentFilterOptions] = useState(null);
  const [isUserDetailsModalOpen, setIsUserDetailsModalOpen] = useState(false);
  const [userDetailsData, setUserDetailsData] = useState([]);

  const [currentUserAccessConfig, setCurrentUserAccessConfig] = useState({});
  const [isUserAccessConfigUpdateModalOpen, setIsUserAccessConfigUpdateModalOpen] = useState(false);
  const [isBulkUserAccessConfigUpdateModalOpen, setIsBulkUserAccessConfigUpdateModalOpen] =
    useState(false);

  const [form] = Form.useForm();

  const fetchUsersList = (page) => {
    axios
      .get(`${ROOT_URL}/admin/users/list`, {
        params: {
          currentPage: page
        }
      })
      .then((res) => {
        const { users, usersCount } = res.data;
        setUserList(users);
        setTotalUsers(usersCount);
        showNotification(
          "Users List Fetched Successfully",
          "Users List Fetched Successfully",
          "success"
        );
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const handleDeleteUser = () => {
    axios
      .delete(`${ROOT_URL}/admin/users/delete`, {
        data: {
          userId: criticalActionUserId
        }
      })
      .then(() => {
        showNotification("User Deleted Successfully", "User Deleted Successfully", "success");
        fetchUsersList(currentPage);
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const handleBlockUser = (userId) => {
    axios
      .post(`${ROOT_URL}/admin/users/handle-block`, {
        userId
      })
      .then(() => {
        showNotification("User Blocked Successfully", "User Blocked Successfully", "success");
        fetchUsersList(currentPage);
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const handleUserSearch = (query) => {
    axios
      .get(`${ROOT_URL}/admin/users/search`, {
        params: {
          query
        }
      })
      .then((res) => {
        const { users, usersCount } = res.data;
        setUserList(users);
        setTotalUsers(usersCount);
        showNotification("User Searched Successfully", "User Searched Successfully", "success");
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const handleUserCoursesView = (userId) => {
    axios
      .get(`${ROOT_URL}/admin/users/courses`, {
        params: {
          userId
        }
      })
      .then((res) => {
        const { purchasedCourses } = res.data;
        setUserPurchasedCourses(purchasedCourses);
        setIsPurchasedCoursesViewModalOpen(true);
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const fetchUserFilterFormRequisites = () => {
    axios
      .get(`${ROOT_URL}/admin/users/form-requisites`)
      .then((res) => {
        setFormRequisites(res.data.formRequisites || {});
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const handleFilterSubmit = (filter) => {
    axios
      .post(`${ROOT_URL}/admin/users/submit-filter`, {
        filter,
        currentPage
      })
      .then((res) => {
        const { users, usersCount } = res.data;
        setUserList(users);
        setTotalUsers(usersCount);
        // setFormRequisites(res.data.formRequisites);
        showSuccessNotification("Filter Applied Successfully.");
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchUsersList(page);
  };

  const handleUserPayments = (userId, paymentIntent, paymentStatus) => {
    axios
      .get(`${ROOT_URL}/admin/users/get-payment-details`, {
        params: {
          userId: userId ? userId : currentUserId,
          paymentIntent,
          paymentStatus
        }
      })
      .then((res) => {
        const { userPayments } = res.data;
        setUserPayments(userPayments);
        setIsPaymentDetailsModalOpen(true);
        !currentUserId && setCurrentUserId(userId);
        !paymentFilterOptions && fetchUserPaymentFormRequisites();
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const fetchUserPaymentFormRequisites = () => {
    axios
      .get(`${ROOT_URL}/admin/users/get-payment-intents-statuses-types`)
      .then((res) => {
        let { paymentIntents, paymentStatuses } = res.data;
        paymentIntents.unshift({ key: "SELECT_INTENT", label: "SELECT_INTENT" });
        paymentStatuses.unshift({ key: "SELECT_STATUS", label: "SELECT_STATUS" });
        setpaymentFilterOptions({ paymentIntents, paymentStatuses });
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const handleAccessConfigStateUpdate = (key, value) => {
    setCurrentUserAccessConfig({
      ...currentUserAccessConfig,
      [key]: value
    });
  };

  const handleUpdateUserAccessConfig = (updatedAccessConfig) => {
    axios
      .post(`${ROOT_URL}/admin/users/update-access-config`, {
        userId: currentUserId,
        updatedAccessConfig
      })
      .then(() => {
        showSuccessNotification("Config updated successfully");
        setIsUserAccessConfigUpdateModalOpen(false);
        fetchUsersList(currentPage);
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const handleBulkUpdateUserAccessConfig = (emailsList, updatedAccessConfig) => {
    axios
      .post(`${ROOT_URL}/admin/users/bulk-update-access-configs`, {
        emailsList,
        updatedAccessConfig
      })
      .then(() => {
        showSuccessNotification(`Config for ${emailsList.length} updated successfully`);
        setIsBulkUserAccessConfigUpdateModalOpen(false);
        fetchUsersList(currentPage);
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const handleTransferSubscriptions = (params) => {
    axios
      .post(`${ROOT_URL}/admin/users/transfer-subscriptions`, {
        userId: currentUserId,
        newEmail: params.newEmail
      })
      .then(() => {
        showSuccessNotification("Subscriptions Transfered Successfully");
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const handleDownloadInvoice = (paymentId, setLoading) => {
    setLoading(true);
    axios
      .get(`${ROOT_URL}/admin/users/payment-invoice`, {
        params: { userId: currentUserId, paymentId }
      })
      .then((res) => {
        window.open(res.data, "_blank");
        showSuccessNotification("Invoice Downloaded Successfully");
      })
      .catch((err) => {
        showErrorNotification(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const columns = [
    {
      title: "S No.",
      dataIndex: "index",
      key: "index"
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name"
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email"
    },
    {
      title: "Contact Number",
      dataIndex: "contactNumber",
      key: "contactNumber",
      render: (_, row) => {
        const number = [row.countryCode, row.contactNumber].filter(Boolean).join(" ");
        return number || "--";
      }
    },
    {
      title: "Description",
      key: "description",
      render: (row) => (
        <Button
          type="primary"
          onClick={() => {
            setCurrentUserId(row.key);
            const requiredData = userList.find((item) => {
              return item.key === row.key;
            });
            setUserDetailsData(requiredData);
            setIsUserDetailsModalOpen(true);
          }}
        >
          View
        </Button>
      )
    },
    {
      title: "Status",
      key: "status",
      render: (row) => {
        let statusObj = { color: "green", text: "ACTIVE" };
        if (row.blocked) {
          statusObj = { color: "red", text: "BLOCKED" };
        }
        return (
          <Tag color={statusObj.color} key={statusObj.text}>
            {statusObj.text.toUpperCase()}
          </Tag>
        );
      }
    },
    {
      title: "Actions",
      key: "action",
      render: (row) => (
        <div
          id="users_row_actions"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around"
          }}
        >
          <Space wrap>
            <>
              {adminConfig?.users?.hasDeleteAccess && (
                <Button
                  type="primary"
                  danger
                  onClick={() => {
                    setIsUserConfirmationAction(true);
                    setUserConfirmationActionMessage("This is a irreversible action!");
                    setCriticalActionUserId(row.key);
                  }}
                >
                  Delete
                </Button>
              )}
              {adminConfig?.users?.hasBlockAccess && (
                <Button
                  type="primary"
                  danger
                  onClick={() => {
                    handleBlockUser(row.key);
                  }}
                >
                  {row.blocked === false ? "Block" : "Unblock"}
                </Button>
              )}
              {adminConfig?.users?.hasPurchasedCoursesAccess && (
                <Button
                  type="primary"
                  onClick={() => {
                    handleUserCoursesView(row.key);
                    setCurrentUserId(row.key);
                    setUserDetailsData(row);
                  }}
                >
                  Purchased Courses
                </Button>
              )}
              {adminConfig?.users?.hasPaymentInfoAccess && (
                <Button
                  type="primary"
                  onClick={() => {
                    handleUserPayments(row.key);
                  }}
                >
                  Payments
                </Button>
              )}
              {adminConfig?.users?.hasUserAccessConfigUpdateAccess && (
                <Button
                  type="primary"
                  onClick={() => {
                    setCurrentUserAccessConfig(row.accessConfig);
                    setCurrentUserId(row.key);
                    setIsUserAccessConfigUpdateModalOpen(true);
                  }}
                >
                  Update Access Config
                </Button>
              )}
            </>
          </Space>
        </div>
      )
    }
  ];

  const prefixSelector = (
    <Form.Item
      name="label"
      rules={[{ required: true, message: "Search label is required" }]}
      noStyle
    >
      <Select placeholder="Search Label" options={searchOptions} size="large" />
    </Form.Item>
  );

  useEffect(() => {
    fetchUsersList(1);
    fetchUserFilterFormRequisites();
  }, []);

  return (
    <div
      style={{
        marginTop: "20px",
        marginLeft: clamp(12, 30),
        marginRight: clamp(12, 30)
      }}
    >
      <Form form={form} name="search" onFinish={handleUserSearch} style={{ width: "100%" }}>
        <Form.Item name="search" rules={[{ required: true, message: "Search value is required!" }]}>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8, alignItems: "center" }}>
            <Input
              addonBefore={prefixSelector}
              style={{ flex: "1 1 auto", width: "min(400px, 100%)" }}
              size="large"
              placeholder="Search Users by Name, Email, Discord ID, Codeforces Handle, Institution Name"
            />
            <Button
              type="primary"
              style={{ width: "min(150px, 100%)" }}
              htmlType="submit"
              size="large"
            >
              Search
            </Button>
          </div>
        </Form.Item>
      </Form>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          gap: "10px"
        }}
      >
        <div
          style={{
            fontSize: "1em"
          }}
        >
          <p>
            Total Users: <b>{totalUsers}</b>
          </p>
        </div>
        <div>
          <Button
            type="primary"
            onClick={() => {
              setCurrentUserAccessConfig(formRequisites?.defaultAccessConfig || {});
              setIsBulkUserAccessConfigUpdateModalOpen(true);
            }}
          >
            Bull Update Access Config
          </Button>
        </div>
      </div>

      <Table
        columns={columns}
        dataSource={userList}
        bordered
        pagination={false}
        scroll={{ x: "max-content" }}
      />
      <br />
      <Pagination
        total={totalUsers}
        showSizeChanger={false}
        showQuickJumper={false}
        pageSize={20}
        current={currentPage}
        onChange={handlePageChange}
      />
      {isUserConfirmationAction === true && (
        <ConfirmationModal
          isModalOpen={isUserConfirmationAction}
          setIsModalOpen={setIsUserConfirmationAction}
          description={userConfirmationActionMessage}
          confirmationAction={handleDeleteUser}
        />
      )}
      {isPurchasedCoursesViewModalOpen === true && (
        <PurchasedCoursesModal
          isModalOpen={isPurchasedCoursesViewModalOpen}
          setIsModalOpen={setIsPurchasedCoursesViewModalOpen}
          adminConfig={adminConfig}
          purchasedCoursesList={userPurchasedCourses}
          userDetailsData={userDetailsData}
          handleTransferSubscriptions={handleTransferSubscriptions}
          handleDownloadInvoice={handleDownloadInvoice}
        />
      )}
      {isPaymentDetailsModalOpen && (
        <PaymentsModal
          isModalOpen={isPaymentDetailsModalOpen}
          setIsModalOpen={setIsPaymentDetailsModalOpen}
          paymentsList={userPayments}
          handleUserPayments={handleUserPayments}
          paymentFilterOptions={paymentFilterOptions}
          userId={currentUserId}
        />
      )}
      {showFiltersSidebar === true && (
        <UsersFilters
          showFilter={showFiltersSidebar}
          onCloseHandler={setShowFilterSidebar}
          handleFilterSubmit={handleFilterSubmit}
          formRequisites={formRequisites}
        />
      )}
      {isUserDetailsModalOpen && (
        <UserDetailsModal
          isModalOpen={isUserDetailsModalOpen}
          setIsModalOpen={setIsUserDetailsModalOpen}
          userDetailsData={userDetailsData}
        />
      )}
      {isUserAccessConfigUpdateModalOpen && (
        <ModifyUserAccessConfigModal
          isModalOpen={isUserAccessConfigUpdateModalOpen}
          setIsModalOpen={setIsUserAccessConfigUpdateModalOpen}
          userAccessConfig={currentUserAccessConfig}
          handleAccessConfigStateUpdate={handleAccessConfigStateUpdate}
          handleUpdateUserAccessConfig={handleUpdateUserAccessConfig}
        />
      )}
      {isBulkUserAccessConfigUpdateModalOpen && (
        <ModifyUserAccessConfigModal
          isModalOpen={isBulkUserAccessConfigUpdateModalOpen}
          setIsModalOpen={setIsBulkUserAccessConfigUpdateModalOpen}
          bulkModificationsEmailFileUploadAPIPath={FILE_UPLOAD_BACKEND_URL}
          userAccessConfig={currentUserAccessConfig}
          isBulkModification={true}
          handleAccessConfigStateUpdate={handleAccessConfigStateUpdate}
          handleBulkUpdateUserAccessConfig={handleBulkUpdateUserAccessConfig}
        />
      )}
    </div>
  );
};

export default UsersDash;
